import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/analytics/AnalyticsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompareProvider"] */ "/vercel/path0/src/components/compare/CompareContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DateRangeProvider"] */ "/vercel/path0/src/components/date/DateRangeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/home/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientFooter","ClientWhatsAppBtn"] */ "/vercel/path0/src/components/layout/ClientComponents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CityProvider"] */ "/vercel/path0/src/lib/CityContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
